import React, {forwardRef, ReactNode} from "react";

const FocusableComponent = (props: { children: ReactNode }, ref: any) => (
    <div ref={ref}>
        {props.children}
    </div>
);
FocusableComponent.displayName = "Focusable"

export const Focusable = forwardRef(FocusableComponent)